/* Copyright (c) 2025 Xperi. All Rights Reserved. */

// eslint-disable-next-line no-shadow
export enum VideoProviderState {
    SUCCESS,
    IN_PROGRESS,
    REFRESH,
    ERROR,
}
